import {
  BidType,
  type EventsOverview,
  type EventsOverviewList,
} from "mws-ts-v2-sdk";

import type { IsoCountryCodeAlpha2 } from "./Misc";

export enum ShippingTypeEnum {
  FreeShipping = "freeShipping",
  PaidShipping = "paidShipping",
  NoShipping = "noShipping",
}

enum MaxBidType {
  Maxbid = "maxbid",
}

// Merge both normal bid type and quick bid types.
// eslint-disable-next-line @typescript-eslint/naming-convention
export const BidAttemptType = {
  ...BidType,
  ...MaxBidType,
};

// Exporting both the type and the enum with the same name allows us to use them in both ways.
export type BidAttemptType = BidType | MaxBidType;

export enum BidModalEnum {
  AddressRequired = "addressRequired",
  LimitWarning = "bidLimitWarning",
  Confirm = "bidConfirm",
  Placed = "bidPlaced",
  PlacedExtended = "bidPlacedExtended",
  Outbid = "outbid",
  OutbidExtended = "outbidExtended",
  ReservationRequired = "reservationRequired",
}

export enum BidErrorType {
  // to be updated with the other error types
  BidTooLow = "bidTooLow",
  BidLimitExceeded = "bidLimitExceeded",
  ProductDoesNotExist = "productDoesNotExist",
  BiddingHasClosed = "biddingHasClosed",
  NoBidUserOrNoExchangeRates = "noBidUserOrNoExchangeRates",
  MissingValues = "missingValues",
}

export type BidError = {
  errorType?: BidErrorType;
  errorCode?: number;
  errorHandler?: () => any;
  bidAmount?: number;
  message: string | "custom-i18n-bid-error";
};

export type Amount = {
  EUR: number;
  [isoCurrency: string]: number;
};

export type Bid = {
  id: string; // uuid
  skuId: string;
  userCountryIso: IsoCountryCodeAlpha2 | null;
  previousBidId: string | null; // link to previous bid, or null if first
  obfuscatedUserId: number;
  amounts: Amount;
  bidType: string; // quick bid or honest bid
  dateCreated: Date;
  bidderIsUser?: boolean; // only for front-end use
};

export enum MediaContentType {
  Video = "video",
  Image = "image",
  Viewer360 = "360viewer",
}

export enum MediaContentTypeV2 {
  Video = "Video",
  Image = "Image",
}

export type ProductBeneficiary = {
  name: string | null;
  description: string | null;
  logoUrl: string | null;
  websiteUrl: string | null;
  isCharity: boolean | null;
  percentage: number | null;
  title: string | null;
};

export type PaginatedList<T> = {
  totalCount: number;
  resultCount: number;
  offset: number;
  pageSize: number;
  results: T[];
};

export type ExtendedEventsOverview = EventsOverview & {
  isFinished: boolean;
};

export type ExtendedEventsOverviewList = EventsOverviewList & {
  results: Array<ExtendedEventsOverview>;
};
